import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Accordion as ExpansionPanel,
  AccordionSummary as ExpansionPanelSummary,
  AccordionDetails as ExpansionPanelDetails,
  withStyles,
} from '@material-ui/core';

import { isCurrentLanguageRtl } from 'modules/language/selectors/language';

import { styles } from './AppointmentAccordionStyles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.node, PropTypes.func]).isRequired,
  children: PropTypes.node.isRequired,
  isInactive: PropTypes.bool,
  hasBorderRadius: PropTypes.bool,
  hasTabs: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  disableExpand: PropTypes.bool,
};

const defaultProps = {
  isInactive: false,
  hasBorderRadius: false,
  hasTabs: false,
  defaultExpanded: false,
  disableExpand: false,
};

const AppointmentAccordion = ({
  classes,
  header,
  children,
  isInactive,
  hasBorderRadius,
  hasTabs,
  defaultExpanded,
  disableExpand,
}) => {
  const [isExpanded, setExpanded] = useState(defaultExpanded);
  const renderHeader = () => typeof header === 'function' ? header(isExpanded) : header;

  return (
    <ExpansionPanel
      className={ classnames(disableExpand ? classes.rootTop : classes.root, classes.expanded, {
        [classes.hasBorderRadius]: hasBorderRadius,
      }) }
      expanded={ isExpanded }
      onChange={ (event, expanded) => !disableExpand ? setExpanded(expanded) : null }
    >
      <ExpansionPanelSummary
        expandIcon={
          <ExpandMoreIcon
            className={ classnames(classes.arrow, {
              [classes.disabledHeader]: isInactive,
            }) }
          />
        }
        classes={{
          expandIcon: isCurrentLanguageRtl() ? classes.iconRtl : classes.icon,
        }}
        className={ classnames(classes.header, {
          [classes.hasBorderRadius]: hasBorderRadius,
          [classes.disabled]: isInactive,
          [classes.disabledHeader]: isInactive,
          [classes.hasTabs]: hasTabs,
        }) }
      >
        { renderHeader() }
      </ExpansionPanelSummary>

      <ExpansionPanelDetails className={ classnames(classes.details, {
        [classes.disabled]: isInactive,
      }) }
      >
        { children }
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

AppointmentAccordion.propTypes = propTypes;
AppointmentAccordion.defaultProps = defaultProps;

export default withStyles(styles)(AppointmentAccordion);
